export default __webpack_public_path__ + "static/media/news172.9c6eaaa5.jpg";